var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.data,"bordered":"","size":"small","pagination":false,"locale":{ emptyText: '暂无数据' },"scroll":{ x: 'calc(700px + 50%)', y: _vm.height }}})}
var staticRenderFns = []

export { render, staticRenderFns }